/**
 * Image Toggle
 * 
 * Toggles between scroll and spread modes for images within a project section.
 * 
 * @returns {void} Initializes the image toggle functionality.
 */
module.exports = function initImageToggle() {
    const toggleButtons = document.querySelectorAll('.z-img-toggle');
    
    toggleButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            const section = button.closest('.z-project');
            const container = section.querySelector('.z-p__container');
            
            if (!container) return;
            
            const isScrollMode = container.classList.toggle('--scroll-mode');
            button.classList.toggle('--scroll');
            
            // Store preference in localStorage
            const sectionId = section.id || 'image-' + Date.now();
            localStorage.setItem(`imgMode-${sectionId}`, isScrollMode ? 'scroll' : 'spread');
        });
    });
    
    // Restore saved preferences
    document.querySelectorAll('.z-project .z-img-toggle').forEach(button => {
        const section = button.closest('.z-project');
        const container = section.querySelector('.z-p__container');
        const sectionId = section.id || 'image-' + Date.now();
        const savedMode = localStorage.getItem(`imgMode-${sectionId}`);
        
        if (savedMode === 'scroll' && container) {
            container.classList.add('--scroll-mode');
            button.classList.add('--scroll');
        }
    });
};